import ReactInputMask from "react-input-mask";
import { Container } from "../Input/styles";

import styled, { css } from "styled-components";

interface StyledInputProps {
  fullfiled?: boolean;
  error?: boolean;
}


const StyledMaskedInput = styled(ReactInputMask)<StyledInputProps>`
  border-radius: 5px;
  padding: 0rem 1rem;
  margin: auto;
  margin-top: 12px;
  background-color: var(--black-100);
  padding: 1rem;
  width: 100%;
  height: 3rem;

  border: 1px solid transparent;
  
  &:focus {
    outline: 0;
    border-color: var(--primary);
  }
  
  ${props => props.fullfiled && !props.error && css`
    border-color: var(--green);
  `}

  ${props => props.error && css`
    border-color: var(--red);
  `}

  &:focus {
    outline: 0;
    border-color: var(--primary);
  }
`;

const RequiredHint = styled.span`
  font-weight: 600;
  color: var(--red);
  
  > span {
    color: var(--white);
  }
`;

interface InputProps {
  id: string;
  name: string;
  type: string;
  placeholder?: string;
  label?: string;
  defaultValue?: string;
  value?: string;
  required: boolean;
  containerClassName?: string;
  inputClassname?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
  error?: any;
  mask?: any;
  formatChars?: { [key: string]: string };
  apiErrorName?: string;
  handleApiErrorRemove?: (errorName: string) => void;
}

function MaskedInput({
  id,
  name,
  type,
  placeholder,
  label,
  required,
  onChange,
  defaultValue,
  onPaste,
  value,
  inputClassname = "",
  containerClassName = "",
  maxLength,
  error,
  onBlur,
  mask,
  duplicatedError,
  formatChars,
  apiErrorName,
  handleApiErrorRemove,
}: any) {
  return (
    <Container className={containerClassName}>
      {(label || required) && (
        <label htmlFor={id}>
          {label}
          {required && <RequiredHint> *</RequiredHint>}
        </label>
      )}

      <StyledMaskedInput
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        required={required}
        value={value}
        onPaste={onPaste}
        className={inputClassname}
        defaultValue={defaultValue}
        onChange={onChange}
        maxLength={maxLength}
        mask={mask}
        onBlur={onBlur}
        formatChars={formatChars}
        onFocus={() =>
          apiErrorName &&
          handleApiErrorRemove &&
          handleApiErrorRemove(apiErrorName)
        }
      />
      {duplicatedError && <small>Valor do campo ja utilizado</small>}
      {!duplicatedError && error && <small>{error}</small>}
    </Container>
  );
}

export default MaskedInput;
